import type {
  BD4TravelElement,
  Recommendation,
} from '@/redux/middleware/googleTagManager/types';

export const mapHotelRecommendedDataToEcommerceElement = (
  recommendation: Recommendation
): BD4TravelElement => ({
  id: recommendation.hotelId,
  prices: {
    // format to Smartseer
    total: Number((recommendation.price / 100).toFixed(0)),
    pp: Number((recommendation.price / recommendation.pax / 100).toFixed(0)),
  },
});
